import { render, staticRenderFns } from "./Payouts.vue?vue&type=template&id=5269b1ca&scoped=true&"
import script from "./Payouts.vue?vue&type=script&lang=ts&"
export * from "./Payouts.vue?vue&type=script&lang=ts&"
import style0 from "./Payouts.vue?vue&type=style&index=0&id=5269b1ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5269b1ca",
  null
  
)

export default component.exports